"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.print = print;
exports.printError = printError;
function print(...args) {
    console.log(...args); // eslint-disable-line no-console
}
function printError(...args) {
    console.error(...args); // eslint-disable-line no-console
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicHJpbnQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvcHJpbnQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQSxzQkFFQztBQUVELGdDQUVDO0FBTkQsU0FBZ0IsS0FBSyxDQUFDLEdBQUcsSUFBZTtJQUN0QyxPQUFPLENBQUMsR0FBRyxDQUFDLEdBQUcsSUFBSSxDQUFDLENBQUEsQ0FBQyxpQ0FBaUM7QUFDeEQsQ0FBQztBQUVELFNBQWdCLFVBQVUsQ0FBQyxHQUFHLElBQWU7SUFDM0MsT0FBTyxDQUFDLEtBQUssQ0FBQyxHQUFHLElBQUksQ0FBQyxDQUFBLENBQUMsaUNBQWlDO0FBQzFELENBQUMifQ==